import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vhbd87rup: FaireProductEntity = {
  token: "p_7vhbd87rup",
  type: "product",
  name: "Slim Sauce Sweet Curry 300ml",
  brandToken: "b_5km4hkec0v",
  brandName: "Eat Water",
  imageUrl:
    "https://cdn.faire.com/fastly/79bc4b1093464de7ec3a97216726afa92c3200975875e960b47e21202fd2478b.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.8,
  description:
    "Top any food or salad with our Slim Sauce Sweet Curry. A vegan, keto friendly, low carbohydrate and low sugar alternative to regular sauces. It is a perfect addition to your kitchen.",
  tags: [],
  msrpDollars: 5.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:12.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
